// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.custom-checkbox label.custom-control-label {\n  width:auto;\n  min-width:0;\n}\ninput[type=\"number\"].gnss-control{\n  width:100px;\n}\ninput[id=\"fillrate\"]::after {\n  content: '%';\n}\n", ""]);
// Exports
module.exports = exports;
